import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastContainer: HTMLElement;

  constructor() {
    this.toastContainer = this.ensureContainerExists();
  }

  private ensureContainerExists(): HTMLElement {
    let container = document.getElementById('toast-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'toast-container';
      container.className = 'toast-container position-fixed top-0 end-0 p-3 z-9999';
      document.body.appendChild(container);
    }
    return container;
  }

  show(
    message: string,
    options?: {
      type?: 'success' | 'danger' | 'info' | 'warning';
      title?: string;
      delay?: number;
    }
  ) {
    const toastEl = document.createElement('div');
    toastEl.className = `toast align-items-center text-bg-${options?.type ?? 'info'} border-0`;
    toastEl.setAttribute('role', 'alert');
    toastEl.setAttribute('aria-live', 'assertive');
    toastEl.setAttribute('aria-atomic', 'true');

    toastEl.innerHTML = `
      <div class="d-flex">
        <div class="toast-body">
          ${options?.title ? `<strong class="me-2">${options.title}</strong>` : ''}${message}
        </div>
        <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
      </div>
    `;

    this.toastContainer.appendChild(toastEl);

    // @ts-ignore
    const bsToast = new bootstrap.Toast(toastEl, {
      delay: options?.delay ?? 3000,
    });
    bsToast.show();

    toastEl.addEventListener('hidden.bs.toast', () => toastEl.remove());
  }
}
